/**
 * @ngdoc component
 * @name common.component:contact
 * @description
 * Componente que permite a los usuarios contactar con el equipo de servicio al cliente.
 *
 */
(function () {
    'use strict';

    var ItxContactCmp = {
        bindings: {
            close: '&'
        },
        controller: ItxContactCmpCtrl,
        templateUrl: 'contact.component.html'
    };

    ItxContactCmpCtrl.$inject = [
        'ItxContactSvc',
        'ItxHubtypeSvc',
        'mdFeelBenefitsService',
        'ItxDateTimeFct'
    ];

    function ItxContactCmpCtrl(
        ItxContactSvc,
        ItxHubtypeSvc,
        mdFeelBenefitsService,
        ItxDateTimeFct
    ) {
        var _this = this;

        _this.dialogReady = false;
        _this.activeChats = false;

        _this.$onInit = function () {
            // Comprobamos si Hubtype esta activo
            ItxHubtypeSvc.isEnabled().then(function (isEnabled) {
                if (isEnabled) {
                    _this.activeChats = true;
                }

                _this.dialogReady = true;
            });

            // Comprueba si el contacto por Whatsapp esta activo
            mdFeelBenefitsService.getWhatsAppInfo().then(function (whatsappConfig) {
                _this.whatsApp = whatsappConfig;
            });

            // Obtenemos información de horarios de atención al cliente
            ItxContactSvc.getStateOfStore().then(function (storeConfig) {
                // Establecemos el horario de atención al cliente
                _this.customerServiceHours = {
                    config: storeConfig,
                    showWeekdays: _this.checkHours(
                        storeConfig.timeWeek.from,
                        storeConfig.timeWeek.to
                    ),
                    showWeekend: _this.checkHours(
                        storeConfig.timeWeekend.from,
                        storeConfig.timeWeekend.to
                    ),
                    showSunday: _this.checkHours(
                        storeConfig.timeSunday.from,
                        storeConfig.timeSunday.to
                    )
                };

                // Añadimos la clase de tamaño en la modal
                _this.addModalClass();
            });

            // Defininimos las distintas vías de contacto
            if (inditex && inditex.iStoreJSON) {
                _this.storePhone = inditex.iStoreJSON.details.supportPhone;
                _this.prefixPhone = inditex.iStoreJSON.details.phoneCountryCode;

                _this.scheduleContactCallCenter = inditex.iStoreJSON.details.scheduleContactCallCenter.find(
                    function (schedule) {
                        return schedule.langId == inditex.iLangId;
                    }
                );
            }
        };

        /**
         * Función para comprobar que las horas del chat estan bien formadas
         */
        _this.checkHours = function (from, to) {
            if (ItxDateTimeFct.isValidHour(from) && ItxDateTimeFct.isValidHour(to)) {
                return true;
            }

            return false;
        };

        /**
         * Función para añadir una clase de tamaño a la modal de contacto
         */
        _this.addModalClass = function () {
            var modal = angular.element(document.getElementsByClassName('contact-dialog'));

            // Si los chats o Whatsapp están activos
            if (_this.activeChats || (_this.whatsApp && _this.whatsApp.enabled)) {
                modal.addClass('ma-modal-md');
            } else {
                modal.addClass('ma-modal-md');
            }
        };

        /**
         * Función para abrir la política de privacidad
         */
        _this.openPolicy = function () {
            window.open(
                inditex.getStaticResourceUrl(
                    'pdf/privacy_policy/' +
                        inditex.iStoreId +
                        '/privacy_policy' +
                        inditex.iLangId +
                        '.pdf'
                ),
                '_blank'
            );
        };
    }
    angular.module('itxApp.common').component('itxContact', ItxContactCmp);
})();
